import React, { useState } from 'react';
import LabelList from './labels/LabelList';
import CreateLabelForm from './labels/CreateLabelForm';
import {
    LabelPickerPopover,
    LabelHeader,
    SectionTitle,
    CloseButton,
} from '../styles/LabelPicker.styles';

const LabelPicker = ({
    labels,
    selectedLabels,
    onClose,
    onCreateLabel,
    onToggleLabel
}) => {
    const [newLabelTitle, setNewLabelTitle] = useState('');
    const [selectedColor, setSelectedColor] = useState('#61bd4f');
    const [isEditing, setIsEditing] = useState(false);
    const [editLabel, setEditLabel] = useState(null);

    const handleCreateLabel = () => {
        if (!newLabelTitle.trim()) return;

        onCreateLabel({
            id: `label-${Date.now()}`,
            title: newLabelTitle.trim(),
            color: selectedColor
        });

        setNewLabelTitle('');
        setSelectedColor('#61bd4f');
    };

    const handleEditLabel = (label) => {
        setEditLabel(label);
        setNewLabelTitle(label.title);
        setSelectedColor(label.color);
        setIsEditing(true);
    };

    const handleSaveEdit = () => {
        if (!newLabelTitle.trim() || !editLabel) return;

        onCreateLabel({
            ...editLabel,
            title: newLabelTitle.trim(),
            color: selectedColor
        });

        setEditLabel(null);
        setNewLabelTitle('');
        setSelectedColor('#61bd4f');
        setIsEditing(false);
    };

    const handleDeleteLabel = () => {
        if (!editLabel) return;

        onCreateLabel({
            ...editLabel,
            deleted: true
        });

        setEditLabel(null);
        setNewLabelTitle('');
        setSelectedColor('#61bd4f');
        setIsEditing(false);
    };

    return (
        <LabelPickerPopover onClick={e => e.stopPropagation()}>
            <LabelHeader>
                <SectionTitle>Labels</SectionTitle>
                <CloseButton onClick={onClose}>×</CloseButton>
            </LabelHeader>

            <LabelList
                labels={labels}
                selectedLabels={selectedLabels}
                onToggleLabel={onToggleLabel}
                isEditing={isEditing}
                onEditLabel={handleEditLabel}
            />

            {editLabel ? (
                <CreateLabelForm
                    title={newLabelTitle}
                    onTitleChange={setNewLabelTitle}
                    selectedColor={selectedColor}
                    onColorSelect={setSelectedColor}
                    onCreateLabel={handleSaveEdit}
                    onDeleteLabel={handleDeleteLabel}
                    isEditing={true}
                    labelName="Save Changes"
                />
            ) : (
                <CreateLabelForm
                    title={newLabelTitle}
                    onTitleChange={setNewLabelTitle}
                    selectedColor={selectedColor}
                    onColorSelect={setSelectedColor}
                    onCreateLabel={handleCreateLabel}
                />
            )}
        </LabelPickerPopover>
    );
};

export default LabelPicker;
